// import React from "react";
// import { useNavigate } from "react-router";

// function BackButton({ buttonName, onClick = null, marginBottom = "26px" }) {
//   const navigate = useNavigate();

//   return (
//     <button
//       className="Back_button"
//       onClick={() => {
//         if (onClick) {
//           onClick();
//         } else {
//           navigate(-1);
//         }
//       }}
//       style={{
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         color: "#0068ff",
//         cursor: "pointer",
//         marginBottom: marginBottom,
//         background: "transparent",
//         border: "none",
//         fontSize: "16px",
//         fontWeight: 500,
//       }}
//     >
//       <i className="fa-solid fa-chevron-left"></i>
//       <span style={{ padding: " 0px 5px" }}>{buttonName}</span>
//     </button>
//   );
// }

// export default BackButton;

import React from "react";
import { useLocation, useNavigate } from "react-router";

function BackButton({
  buttonName,
  fallbackPath = null,
  handleClick = null,
  onClick = null,
  marginB = "20px",
  goBack = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  // console.warn("location", location.state?.from);

  // const handleBack = () => {
  //     if (handleClick) handleClick();
  //     if (fallbackPath) {
  //         navigate(fallbackPath);
  //     } else {
  //         navigate(-1);
  //     }
  // };
  const handleBack = () => {
    const clickHandler = handleClick || onClick;
    if (clickHandler) {
      clickHandler();
      return;
    }
    if (goBack) {
      navigate(-1);
    } else if (location.state?.from) {
      navigate(location.state?.from); // Use where user actually came from
    } else if (fallbackPath) {
      navigate(fallbackPath); // Use explicit fallback
    } else {
      navigate(-1); // Last resort
    }
  };

    return (
        <div
            className='Back_button mb-2'
            onClick={handleBack}
            style={{ cursor: "pointer", display: "flex", alignItems: "center", color: "#0068ff", marginBottom: {marginB} }}
        >
            <i className="fa-solid fa-chevron-left"></i>
            <span style={{ padding: "0px 5px" }}>{buttonName}</span>
        </div>
    );
}

export default BackButton;
